import { Expense } from "../../expense/expense";


export class responseGetExpense {
    expense:Expense = new Expense();
    constructor (data) {
        this.expense.onInit(data);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/http/res/response-get-expense.ts